var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowsPlayerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 29,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1959 34.3923L34.1959 24L43.1959 29.1962L34.1959 34.3923Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.5H22C21.8103 20.4069 25.8435 14.4324 37 14V14.5V17C28.4586 18.6716 26.2501 22.0151 25 30.5Z",
    fill: "#FF003C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 17.0064V14.0064C46.0931 13.8167 52.5676 16.8435 53 28H51.5L49.5 28.5C47.8284 19.9585 44.4849 18.2565 36 17.0064Z",
    fill: "#07C180"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28L53 27.5C53.1897 37.5931 49.1565 43.5676 38 44L37.5 41C46.0415 39.3284 48.7499 36.4849 50 28Z",
    fill: "#FFD01E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 41V44C28.4069 44.1897 22.4324 40.1565 22 29H22.5H25C26.6716 37.5414 30.0151 39.7499 38.5 41Z",
    fill: "#1989FA",
    fillOpacity: 0.970833
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsPlayerLogo);
export default __webpack_public_path__ + "static/media/windows-player-logo.06b0409e6368ad7d1312da2fdea35432.svg";
export { ForwardRef as ReactComponent };